"use client"

import React from "react"
import styles from "styles/global.module.scss"

export default function App({ children }: { children: React.ReactNode }) {
  return <div className={styles.mainContainer}>{children}</div>
}
